import { Component, OnInit } from '@angular/core';
import { CookieBannerService } from './cookie-banner.service';

@Component({
  selector: 'app-cookie-banner',
  template: '', // Deze component heeft geen eigen HTML meer nodig.
  standalone: false,
})
export class CookieBannerComponent implements OnInit {
  // Injecteer de nieuwe, centrale service.
  constructor(private cookieBannerService: CookieBannerService) {}

  ngOnInit(): void {
    // Vraag de service om de banner te tonen indien nodig.
    this.cookieBannerService.showBannerIfNeeded();
  }
}
